/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationTriggerRuleDto } from './IntegrationTriggerRuleDto';
import {
    IntegrationTriggerRuleDtoFromJSON,
    IntegrationTriggerRuleDtoFromJSONTyped,
    IntegrationTriggerRuleDtoToJSON,
    IntegrationTriggerRuleDtoToJSONTyped,
} from './IntegrationTriggerRuleDto';
import type { TriggerEventEnvelope } from './TriggerEventEnvelope';
import {
    TriggerEventEnvelopeFromJSON,
    TriggerEventEnvelopeFromJSONTyped,
    TriggerEventEnvelopeToJSON,
    TriggerEventEnvelopeToJSONTyped,
} from './TriggerEventEnvelope';

/**
 * 
 * @export
 * @interface TriggerEvaluateRequest
 */
export interface TriggerEvaluateRequest {
    /**
     * 
     * @type {TriggerEventEnvelope}
     * @memberof TriggerEvaluateRequest
     */
    envelope?: TriggerEventEnvelope;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TriggerEvaluateRequest
     */
    envelopeMap?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof TriggerEvaluateRequest
     */
    ruleId?: string;
    /**
     * 
     * @type {IntegrationTriggerRuleDto}
     * @memberof TriggerEvaluateRequest
     */
    ruleDraft?: IntegrationTriggerRuleDto;
    /**
     * 
     * @type {boolean}
     * @memberof TriggerEvaluateRequest
     */
    structuralOnly?: boolean;
}

/**
 * Check if a given object implements the TriggerEvaluateRequest interface.
 */
export function instanceOfTriggerEvaluateRequest(value: object): value is TriggerEvaluateRequest {
    return true;
}

export function TriggerEvaluateRequestFromJSON(json: any): TriggerEvaluateRequest {
    return TriggerEvaluateRequestFromJSONTyped(json, false);
}

export function TriggerEvaluateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerEvaluateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'envelope': json['envelope'] == null ? undefined : TriggerEventEnvelopeFromJSON(json['envelope']),
        'envelopeMap': json['envelopeMap'] == null ? undefined : json['envelopeMap'],
        'ruleId': json['ruleId'] == null ? undefined : json['ruleId'],
        'ruleDraft': json['ruleDraft'] == null ? undefined : IntegrationTriggerRuleDtoFromJSON(json['ruleDraft']),
        'structuralOnly': json['structuralOnly'] == null ? undefined : json['structuralOnly'],
    };
}

export function TriggerEvaluateRequestToJSON(json: any): TriggerEvaluateRequest {
    return TriggerEvaluateRequestToJSONTyped(json, false);
}

export function TriggerEvaluateRequestToJSONTyped(value?: TriggerEvaluateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'envelope': TriggerEventEnvelopeToJSON(value['envelope']),
        'envelopeMap': value['envelopeMap'],
        'ruleId': value['ruleId'],
        'ruleDraft': IntegrationTriggerRuleDtoToJSON(value['ruleDraft']),
        'structuralOnly': value['structuralOnly'],
    };
}

